
<div mat-dialog-title class="dialog-info horizontal-padding m-0" closeOnEscape>
    <label class="dialogTitle">
        {{'REQUEST' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" [mat-dialog-close]></button>
</div>
    <mat-dialog-content class="horizontal-padding">
        <div>
            <label class="mt-0 mb-2">
                {{'POLICY_MANDATED_APPROVERS' | translate}}
            </label>

            <div class="table-wrapper">
                <table mat-table [dataSource]="dataSource" class="mat-elevation table-responsive table-border-bottom">
                    <ng-container matColumnDef="role">
                        <th mat-header-cell *matHeaderCellDef class="col-role text-center horizontal-padding">
                            {{'ROLE' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="col-role horizontal-padding">
                            {{element.role}} 
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="reviewer">
                        <th mat-header-cell *matHeaderCellDef class="col-reviewer text-center horizontal-padding">
                            {{'REVIEWER' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="col-reviewer horizontal-padding"> 
                            {{element.reviewer}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef class="text-center horizontal-padding">
                            {{'EMAIL' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="horizontal-padding">
                            {{element.email}} 
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="requiredBy">
                        <th mat-header-cell *matHeaderCellDef class="text-center horizontal-padding">
                            {{'REQUIRED_BY' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="horizontal-padding">
                            <div class="date-input-wrapper">
                                <input matInput class="date-input-field p-0" 
                                    [matDatepicker]="requiredByPicker" 
                                    [value]="element.requiredBy" 
                                    [min]="minDate"
                                    (dateChange)="onRequiredByDateChange($event, element)"
                                    placeholder="{{'SELECT_DATE' | translate}}">
                                <mat-datepicker-toggle class="date-picker-toggle" matSuffix [for]="requiredByPicker"></mat-datepicker-toggle>
                                <mat-datepicker #requiredByPicker></mat-datepicker>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="row-height table-header-row"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row-height table-row"
                        (click)="selectedRow = row" [class.selected]="selectedRow === row">
                    </tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell no-data row-height" [attr.colspan]="displayedColumns.length">
                            {{'NO_DATA_FOUND' | translate}}
                        </td>
                    </tr>
                </table>
            </div>
            <div class="mt-3 mb-3">
                <button mat-raised-button color="primary" (click)="showReviewerDialog(true)" [disabled]="dataSource.length === 0">
                    {{'MODIFY_REVIEW_BTN_LABEL' | translate}}
                </button>
            </div>
        </div>
        <div>
            <label class="mt-0 mb-2">
                {{'USER_ADDED' | translate}}
            </label>

            <div class="table-wrapper">
                <table mat-table [dataSource]="dataSourceApprovers" class="mat-elevation table-responsive table-border-bottom">
                    <ng-container matColumnDef="role">
                        <th mat-header-cell *matHeaderCellDef class="col-role text-center horizontal-padding">
                            {{'ROLE' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="col-role horizontal-padding">
                            {{element.role}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="reviewer">
                        <th mat-header-cell *matHeaderCellDef class="col-reviewer text-center horizontal-padding">
                            {{'REVIEWER' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="col-reviewer horizontal-padding">
                            {{element.reviewer}} 
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef class="col-email text-center horizontal-padding">
                            {{'EMAIL' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="col-email horizontal-padding"> 
                            {{element.email}} 
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="requiredBy">
                        <th mat-header-cell *matHeaderCellDef class=" text-center horizontal-padding">
                            {{'REQUIRED_BY' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="horizontal-padding">
                            <div class="date-input-wrapper">
                                <input matInput class="date-input-field p-0" [matDatepicker]="requiredByPicker" [value]="element.requiredBy" 
                                [min]="minDate" (dateChange)="onRequiredByDateChange($event, element)" placeholder="{{'SELECT_DATE' | translate}}">
                                <mat-datepicker-toggle class="date-picker-toggle" matSuffix [for]="requiredByPicker"></mat-datepicker-toggle>
                                <mat-datepicker #requiredByPicker></mat-datepicker>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="remove">
                        <th mat-header-cell *matHeaderCellDef class="shrink-col-width"></th>
                        <td mat-cell *matCellDef="let element" class=" h-100 d-flex horizontal-padding align-items-center justify-content-center "> 
                            @if(selectedRow === element) {
                                <mat-icon class="d-flex align-items-center justify-content-center delete-icon-color" 
                                    (click)="removeSelectedUser(element.reviewer)">delete_outline</mat-icon>
                            }
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsApprovers" class="row-height table-header-row"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsApprovers;" class="row-height table-row w-100"
                        (click)="selectedRow = row" [class.selected]="selectedRow === row">
                    </tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell no-data row-height" [attr.colspan]="displayedColumnsApprovers.length">
                            {{'NO_DATA_FOUND' | translate}}
                        </td>
                    </tr>
                </table>  
            </div>
                    
            <div class="mt-3 mb-3">
                <button mat-raised-button color="primary" (click)="showReviewerDialog(false)" [disabled]="isAddReviewerDisabled" class="justify-content-center align-items-center">
                    <mat-icon class="w-auto m-0">add</mat-icon>
                    {{'ADD_REVIEWER_BTN_LABEL' | translate}}
                </button>
            </div>
        </div>
        <div [formGroup]="costReviewRequestForm">
            <div class="row m-0">
                <label class="mb-2 p-0">
                    {{'REVIEW_CANCEL_DIALOG_REPORT_ADD_EMAIL_NOTE' | translate}}
                </label>
                <div class="col-sm-12 p-0">
                    <mat-form-field appearance="outline" class="col-sm-12 adjust-emailNote-height">
                        <textarea class="col-sm-12 text-area-resize"
                            matInput 
                            rows="4"
                            formControlName="emailNote">
                        </textarea>
                </mat-form-field>
                </div>
            </div>
    
            <div class="row col-sm-12 m-0">
                <mat-radio-group formControlName="emailRequestType" class="p-0" (change)="onRequestTypeChange($event)">
                    <div class="row col-sm-12 align-items-center m-0 p-0">
                        <div class="col-sm-6 p-0">
                            <mat-radio-button class="display-block align-radio-button" color="primary" value="0">
                                {{'REVIEW_CANCEL_DIALOG_REPORT_SEND_REQUEST_OPEN_EMAIL' | translate}}
                            </mat-radio-button>
                        </div>
                        <div class="col-sm-6 p-0">
                            <div class="row col-sm-4 m-0">
                                <button mat-raised-button color="primary" 
                                    class="justify-content-center align-items-center"
                                    (click)="showCCRecipientDialog()"
                                    [disabled]="!addCcRecipientEnabled">
                                        <mat-icon class="w-auto m-0">add</mat-icon>
                                        {{'ADD_CC_RECIPIENT_LABEL' | translate}}
                                </button>
                            </div>
                        
                        </div>
                    </div>

                    <div class="row col-sm-12 align-items-end m-0 p-0">
                        <div class="col-sm-6 p-0 pe-3">
                            <fieldset>
                                <legend>
                                    <mat-radio-button class="display-block" color="primary" value="1">
                                        {{'REVIEW_CANCEL_DIALOG_REPORT_SEND_REQUEST_AUTO' | translate}}
                                    </mat-radio-button>
                                </legend>
                            
                                <div class="margin-left">
                                    <div class="row row-height m-0">
                                        <label class="col-sm-2 p-0 d-flex align-items-center">
                                            {{'REVIEW_CANCEL_DIALOG_REPORT_1' | translate}}
                                        </label>
                                        <app-multi-pdf-report-dropdown class="col-sm-10 p-0"
                                            [reportsList]="reportsList"
                                            [control]="costReviewRequestForm.controls.report1"
                                            [showEmptyOption]="true">
                                        </app-multi-pdf-report-dropdown>
                                    </div>
                                    <div class="row row-height m-0">
                                        <label class="col-sm-2 p-0 d-flex align-items-center">
                                            {{'REVIEW_CANCEL_DIALOG_REPORT_2' | translate}}
                                        </label>
                                        <app-multi-pdf-report-dropdown class="col-sm-10 p-0"
                                            [reportsList]="reportsList"
                                            [control]="costReviewRequestForm.controls.report2"
                                            [showEmptyOption]="true">
                                        </app-multi-pdf-report-dropdown>
                                    </div>
                                    <div class="row row-height m-0">
                                        <label class="col-sm-2 p-0 d-flex align-items-center">
                                            {{'REVIEW_CANCEL_DIALOG_REPORT_3' | translate}}
                                        </label>
                                        <app-multi-pdf-report-dropdown class="col-sm-10 p-0"
                                            [reportsList]="reportsList"
                                            [control]="costReviewRequestForm.controls.report3"
                                            [showEmptyOption]="true">
                                        </app-multi-pdf-report-dropdown>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div class="col-sm-6 p-0">
                            <fieldset>
                            <legend>
                                {{'CC_RECIPIENT_LEGEND' | translate}}
                            </legend>
                            <div class="row m-0 align-items-center">
                                <div class="col-sm-1 p-0">
                                    <table mat-table [dataSource]="dataSourceCCTable" class="mat-elevation table-responsive CC-table-margin">
                                        <ng-container matColumnDef="CC">
                                            <th mat-header-cell *matHeaderCellDef class="border-0"></th>
                                            <td mat-cell *matCellDef="let element" class="p-0 text-start border-0 remove-background-color"> 
                                                {{element}}
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedColumnsCCTable" class="CC-table-header-row"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumnsCCTable;" class="row-height"
                                                [class.selected]="selectedRow === row">
                                        </tr>
                                    </table>
                                </div>
                                
                                <div class="col-sm-11 p-0">
                                    <table mat-table [dataSource]="dataSourceCCRecipient" class="mat-elevation table-responsive table-border-bottom CC-table-margin">
                                        <ng-container matColumnDef="email">
                                            <th mat-header-cell *matHeaderCellDef></th>
                                            <td mat-cell *matCellDef="let element" class="horizontal-padding "> 
                                                {{element.email}} 
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="remove">
                                            <th mat-header-cell *matHeaderCellDef class="shrink-col-width"></th>
                                            <td mat-cell *matCellDef="let element" class=" h-100 d-flex horizontal-padding align-items-center justify-content-center "> 
                                                @if(isValidRowSelected(element)) {
                                                    <mat-icon class="d-flex align-items-center justify-content-center delete-icon-color" 
                                                        (click)="removeSelectedCCRecipient(element.email)">delete_outline</mat-icon>
                                                }
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedColumnsCCRecipient" class="CC-table-header-row"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumnsCCRecipient;" class="row-height table-row"
                                            (click)="selectedRow = row" [class.selected]="isValidRowSelected(row)">
                                        </tr>
                                    </table> 
                                </div>
                                
                            </div>
                            
                            </fieldset>
                        </div>
                    </div>
                </mat-radio-group>        
            </div>    
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="dialog-actions-style">
        <button mat-raised-button color="primary" (click)="onSend()" [disabled]="isSendDisabled">
            {{'SEND_BTN_LABEL' | translate}}
        </button>
        <button mat-raised-button color="warn" mat-dialog-close>
            {{'CANCEL_BTN_LABEL' | translate}}
        </button>
    </mat-dialog-actions>
